import { apiRoot } from "./apiRoot";
import { MysqlID, Paginated } from "./upsellApi";

const timescheduleEndpoints = apiRoot.enhanceEndpoints({
  addTagTypes: ["Timeschedule"],
});

export type Timeschedule = {
  id: MysqlID;
  name: string;
};

export const timescheduleApi = timescheduleEndpoints.injectEndpoints({
  endpoints: (builder) => ({
    fetchTimeschedules: builder.query<Paginated<Timeschedule>, { salesarea_id: number }>({
      query: ({ salesarea_id }) => {
        return {
          url: `/timeschedules?filter[salesarea_id][]=${salesarea_id}&per_page=100`,
          method: "GET",
        };
      },
    }),
  }),
});

export const { useFetchTimeschedulesQuery } = timescheduleApi;
